import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.FavouriteBtn, {
    directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
    class: _setup.isMobile ? "rounded-15" : "rounded-20",
    attrs: {
      type: "lpu",
      size: _setup.isMobile ? 36 : 52,
      "target-id": _vm.lpuId,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }